<mbs-modal
  #modal
  [isCustomModal]="true"
  [limitedHeight]="true"
  [title]="'shared:administrators.presets.applyPreset' | i18next">
  <ng-container modal-body>
    <div class="fw-semibold mb-2">{{ 'shared:administrators.presets.presets' | i18next }}</div>

    @for (preset of presets(); track preset.id) {
      <div class="preset-row d-flex align-items-center">
        <mbs-radio
          [formControl]="selectedPresetId"
          [id]="'preset-' + preset.id"
          [label]="preset.name"
          [value]="preset.id"></mbs-radio>

        <mbs-button
          class="preset-row_edit ml-2"
          type="link"
          [icon]="'ico ico-Pencil'"
          [size]="MbsSize.sm"
          (click)="handleEdit(preset)"></mbs-button>
      </div>
    } @empty {
      <div class="text-muted">{{ 'shared:administrators.presets.noPresets' | i18next }}</div>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="!selectedPresetId.value"
      (click)="apply()">
      {{ 'shared:buttons.apply' | i18next }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
